import type { NpcBody, RoleDefinitionBody } from './types'

export function parseKeyValueList(raw: string): Record<string, string> {
  const result: Record<string, string> = {}
  for (const entry of raw.split(',').map(value => value.trim()).filter(Boolean)) {
    const separator = entry.indexOf('=')
    if (separator <= 0 || separator === entry.length - 1) continue
    result[entry.slice(0, separator).trim()] = entry.slice(separator + 1).trim()
  }
  return result
}

export function exactDialogueSelection(current: string[], id: string, selected: boolean): string[] {
  const values = new Set(current)
  if (selected) values.add(id)
  else values.delete(id)
  return [...values]
}

export function applyRoleDefaults(
  current: NpcBody,
  role: RoleDefinitionBody & { id: string },
): NpcBody {
  return {
    ...current,
    role: 'custom',
    customRole: role.id,
    personality: structuredClone(role.defaultPersonality),
    activities: [...role.defaultActivityIds],
    schedule: {
      ...current.schedule,
      populationPriority: Math.max(0, Math.min(100, role.populationPriority)),
    },
  }
}

export function newStructuredArrayItem(label: string, current: unknown[]): unknown {
  const prototypes: Record<string, unknown> = {
    windows: { startMinute: 480, endMinute: 1020, days: [0, 1, 2, 3, 4, 5, 6], arrivalFlexMinutes: 15, departureFlexMinutes: 15 },
    points: { minute: 720, fraction: .5 },
    steps: { id: `step-${crypto.randomUUID()}`, dialoguePackageId: '', checkpoints: [], completionFraction: .75, realTimeCooldownMinutes: 0, prerequisiteFlags: [], grantedFlags: [] },
    checkpoints: { id: `checkpoint-${crypto.randomUUID()}`, timestampMillis: 0, minimumHeardFraction: .75, requiredForCompletion: true },
    detours: {
      destinationId: '',
      reason: '',
      maximumDurationMinutes: 10,
      meetingPointId: '',
      rejoinCondition: 'reached_meeting_point',
      fallback: 'continue_slowly',
    },
    branches: { condition: '', nextPhaseId: '' },
    conditions: { type: 'weather', value: 'clear' },
    variants: { id: `variant-${crypto.randomUUID()}`, overrides: {} },
  }
  if (label in prototypes) return structuredClone(prototypes[label])
  if (current.length > 0 && current[0] !== null && typeof current[0] === 'object') return structuredClone(current[0])
  return ''
}
